<ion-header class="extendido" *ngIf="loaded">
  <ion-buttons>
    <ion-button (click)="closeModal()">
       <i class="fa-regular fa-chevron-left chevron-back-button" *ngIf="!currentUrl"></i>
    </ion-button>

    <ion-title>{{'Acompanhamentos' | translate}}</ion-title>
  </ion-buttons>
</ion-header>
<app-loading-spinner *ngIf="!loaded"></app-loading-spinner>

<ion-content *ngIf="loaded">
  <div class="gradient-extendido">
    <ion-segment mode="ios" value="acompanhamento" [(ngModel)]="tipo" class="segment-gradient-title">
      <ion-segment-button value="acompanhamento">
        <ion-label class="header">{{'Acompanhamentos' | translate}}</ion-label>
      </ion-segment-button>

      <ion-segment-button value="compromisso">
        <ion-label class="header">{{'Compromissos' | translate}}</ion-label>
      </ion-segment-button>
    </ion-segment>
  </div>

  <div [ngSwitch]="tipo">
    <div *ngSwitchCase="'acompanhamento'">
      <ion-grid>
        <ion-row class="ion-align-items-center">
          <ion-col size="8">
            <ion-segment mode="ios" class="segment-min" value="meu" [(ngModel)]="caseTipo">
              <ion-segment-button value="meus">
                <ion-label>{{ 'Meus' | translate }}</ion-label>
              </ion-segment-button>
              <ion-segment-button value="equipe">
                <ion-label>{{ 'Equipe' | translate }}</ion-label>
              </ion-segment-button>
            </ion-segment>
          </ion-col>

          <ion-col size="4" class="ion-text-right">
            <ion-button
              (click)="filtrar()"
              shape="round"
              fill="outline"
              size="small"
              color="medium"
              class="button-filter"
            >
              {{'Filtrar' | translate}}
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-grid>

      <div [ngSwitch]="caseTipo">
        <div *ngSwitchCase="'meus'">
          <div class="gradient-extendido-div">
            <ion-grid *ngFor="let meu of meusAcompanhamentos; let i = index">
              <div
                *ngIf="meu.acompanhamentoAtrasado === 1 && isPrimeiroAtrasado(meusAcompanhamentos, i)"
                class="div-top"
              >
                <ion-note slot="start">
                  <i class="fa-solid fa-bell red"></i>
                </ion-note>
                <ion-label class="color-title red">
                  {{ 'Você possui ' | translate }} {{ acompanhamentoAtrasados.length }} {{
                  acompanhamentoAtrasados.length === 1 ? ('acompanhamento atrasado' | translate) : ('acompanhamentos
                  atrasados' | translate) }}
                </ion-label>
              </div>

              <div *ngIf="meu.acompanhamentoAtrasado === 0 && isPrimeiroEmDia(meusAcompanhamentos, i)" class="div-top">
                <ion-note slot="start">
                  <i class="fas fa-user-check div-icon div-icon"></i>
                </ion-note>
                <ion-label class="color-title"> {{ 'Meus acompanhamentos' | translate }} </ion-label>
              </div>

              <ion-row (click)="gerenciar(meu, tipo)">
                <ion-col size="11">
                  <ion-card
                    class="card"
                    [ngClass]="{'card-compromisso': meu.acompanhamentoAtrasado == 0
                  , 'card-compromisso-atrasado': meu.acompanhamentoAtrasado == 1}"
                  >
                    <ion-list>
                      <ion-item lines="none">
                        <div class="alinhamento-colum">
                          <i
                            [ngStyle]="{'color': getFontColor(meu)}"
                            class="{{getIcon(meu)}} icone-acompanhamento icon-titulo"
                          >
                            <ion-label class="titulo-item" [ngStyle]="{'color': getFontColor(meu)}">
                              {{meu.acao}}
                            </ion-label>
                          </i>
                          <ion-label class="date capitalize">{{meu.categoria}}</ion-label>
                        </div>
                      </ion-item>

                      <ion-item lines="none">
                        <div class="alinhamento-colum">
                          <p class="date capitalize" style="margin: 0" *ngIf="meu.acompanhamentoAtrasado == 0">
                            {{'Status: '  | translate}}
                            <span
                              [ngClass]="{
                                'green': meu.tipo == '0',
                                'red': meu.tipo == '2',
                                'orange': meu.tipo == '1'
                              }"
                            >
                              {{meu.status | translate}}
                            </span>
                          </p>
                          <ion-label class="date">
                            {{meu.datahora | dateFormat:"mediaHora"}}
                          </ion-label>
                          <p class="atrasado" *ngIf="isAtrasado(meu.datahora) && meu.tipo == 1 && meu.isCompromisso == 0">
                            <i class="fa-solid fa-clock"></i>
                            {{'Atrasado' | translate}}
                          </p>
                        </div>
                      </ion-item>

                      <ion-item lines="none">
                        <p class="date capitalize">
                          <i class="fa-solid fa-eye"></i>
                          <span> {{meu.restrito == '1' ? ('Restrito' | translate) : ('Público' | translate)}} </span>
                        </p>
                      </ion-item>
                    </ion-list>
                  </ion-card>
                </ion-col>

                <ion-col class="alinhamento" size="1">
                  <i class="fa-regular fa-chevron-right"></i>
                </ion-col>
              </ion-row>
              <div
                [ngClass]="{'border-bottom': meu === acompanhamentoAtrasados[acompanhamentoAtrasados.length - 1]}"
              ></div>
            </ion-grid>

            <sem-registro
              [text]="'Nenhum Acompanhamento encontrado'"
              *ngIf="!meusAcompanhamentos.length"
            ></sem-registro>
          </div>
        </div>

        <div *ngSwitchCase="'equipe'">
          <div class="gradient-extendido-div">
            <ion-grid *ngFor="let equipe of equipeAcompanhamentos; let i = index" (click)="detalhes(equipe, tipo)">
              <div
                class="div-top"
                *ngIf="equipe.acompanhamentoAtrasado === 1 && isPrimeiroAtrasado(equipeAcompanhamentos, i)"
              >
                <ion-note slot="start">
                  <i class="fa-solid fa-bell red"></i>
                </ion-note>
                <ion-label class="color-title red"> {{'Acompanhamentos atrasados da equipe' | translate}} </ion-label>
              </div>

              <div
                class="div-top"
                *ngIf="equipe.acompanhamentoAtrasado === 0 && isPrimeiroEmDia(equipeAcompanhamentos, i)"
              >
                <ion-note slot="start">
                  <i class="fas fa-user-check div-icon"></i>
                </ion-note>

                <ion-label class="color-title"> {{'Acompanhamentos da equipe' | translate}} </ion-label>
              </div>
              <ion-row>
                <ion-col size="11">
                  <ion-card
                    class="card"
                    [ngClass]="{'card-compromisso': equipe.acompanhamentoAtrasado == 0
                    ,'card-compromisso-atrasado': equipe.acompanhamentoAtrasado == 1}"
                  >
                    <ion-list>
                      <ion-item lines="none">
                        <div class="alinhamento-colum">
                          <i
                            [ngStyle]="{'color': getFontColor(equipe)}"
                            class="{{getIcon(equipe)}} icone-acompanhamento icon-titulo"
                          >
                            <ion-label
                              clas="titulo-item"
                              style="margin: 0 10px"
                              [ngStyle]="{'color': getFontColor(equipe)}"
                            >
                              {{equipe.acao}}
                            </ion-label>
                          </i>
                          <ion-label class="date capitalize">{{equipe.categoria}}</ion-label>
                        </div>
                      </ion-item>

                      <ion-item lines="none">
                        <div class="alinhamento-colum">
                          <ion-label class="date">
                            {{equipe.datahora | dateFormat:"mediaHora"}}
                          </ion-label>

                          <p class="date capitalize" style="margin: 0">
                            {{'Status: '  | translate}}
                            <span
                              [ngClass]="{
                                'green': equipe.tipo == '0',
                                'red': equipe.tipo == '2',
                                'orange': equipe.tipo == '1'
                              }"
                            >
                              {{equipe.status | translate}}
                            </span>
                          </p>
                        </div>
                      </ion-item>

                      <ion-item lines="none">
                        <p class="date capitalize">
                          <i class="fa-solid fa-eye"></i>
                          <span> {{equipe.restrito == '1' ? ('RESTRITO' | translate) : ('PÚBLICO' | translate)}} </span>
                        </p>
                      </ion-item>
                    </ion-list>
                  </ion-card>
                </ion-col>

                <ion-col class="alinhamento" size="1">
                  <i class="fa-regular fa-chevron-right"></i>
                </ion-col>
              </ion-row>
            </ion-grid>

            <sem-registro
              [text]="'Nenhum Acompanhamento encontrado'"
              *ngIf="!equipeAcompanhamentos.length"
            ></sem-registro>
          </div>
        </div>
      </div>
    </div>

    <div *ngSwitchCase="'compromisso'">
      <div class="gradient-extendido-div">
        <div class="div-top" *ngIf="meusCompromissos.length">
          <ion-note slot="start">
            <i class="fa-solid fa-calendar-check div-icon"></i>
          </ion-note>
          <ion-label class="color-title"> {{'Meus Compromissos' | translate}} </ion-label>
        </div>
          
        <ion-grid *ngFor="let meu of meusCompromissos; let i = index">
          <ion-row (click)="gerenciar(meu, tipo)">
            <ion-col size="11">
              <ion-card class="card card-compromisso">
                <ion-list>
                  <ion-item lines="none">
                    <div class="alinhamento-colum">
                      <i
                        [ngStyle]="{'color': getFontColor(meu)}"
                        class="{{getIcon(meu)}} icone-acompanhamento icon-titulo"
                      >
                        <ion-label class="titulo-item">{{meu.acao}}</ion-label>
                      </i>
                      <ion-label class="date">
                        {{meu.datahora | dateFormat:"mediaHora"}}
                      </ion-label>
                    </div>
                  </ion-item>

                  <ion-item lines="none">
                    <div class="alinhamento-colum">
                      <p class="item-titulo">
                        {{'Título: ' | translate}}
                        <span class="date capitalize">{{meu.titulo}}</span>
                      </p>
                      <p class="item-titulo">
                        {{'Detalhes: ' | translate}}
                        <span class="date capitalize">{{meu.descricao}}</span>
                      </p>
                    </div>
                  </ion-item>
                  <ion-item lines="none"></ion-item>
                </ion-list>
              </ion-card>
            </ion-col>

            <ion-col class="alinhamento" size="1">
              <i class="fa-regular fa-chevron-right"></i>
            </ion-col>
          </ion-row>

          <div class="border-bottom"></div>
        </ion-grid>

        <sem-registro [text]="'Nenhum Compromisso encontrado'" *ngIf="!meusCompromissos.length"></sem-registro>
      </div>
    </div>
  </div>
</ion-content>

<ion-fab class="fabs" slot="fixed" vertical="bottom" horizontal="end" *ngIf="loaded">
  <ion-fab-button>
    <i class="fa-regular fa-plus"></i>
  </ion-fab-button>

  <ion-fab-list side="start" [ngSwitch]="tipo">
    <ion-fab-button
      class="color-fab-button"
      style="--border-radius: 15px 15px 0 0 !important"
      (click)="addAcompanhamento(tipo)"
    >
      {{ tipo === 'acompanhamento' ? ('Novo acompanhamento' | translate) : ('Novo compromisso' | translate) }}
    </ion-fab-button>

    <ion-fab-button
      class="color-fab-button"
      style="--border-radius: 0 0 15px 15px !important"
      (click)="historicoAcompanhamento()"
    >
      {{'Histórico' | translate}}
    </ion-fab-button>
  </ion-fab-list>
</ion-fab>
